
/** package import */

import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Footer from './Footer';
import { Tabs, Tab } from 'react-bootstrap';
import FooterNew from "./FooterNew";


/** local file import */

import HeaderNew from './HeaderNew';
import { GetAllCmsData, getLaunchpadData } from '../Hooks/UseBackend';
import LaunchpadCont from './LaunchpadCont';
import bannerVideo from '../Assets/ainfra/videos/launchpad_video.mp4'
import Loader from './Loader';


const Launchpad = () => {
    const [masp, setMasp] = useState(false)
    const [totalLaunchPadlength, settotalLaunchPadlength] = useState([])
    const [section1, setsection1] = useState();


    useEffect(() => {
        getCmsData();
    }, []);


    const getCmsData = async () => {
        console.log("enterthis");
        let res = await GetAllCmsData();

        if (res.data) {
            setsection1(res.data.find((value) => (value.identifier == 'launch X')))
        }


        // setCmsData(res.data);
    };


    useEffect(() => {

        getData()
    }, [])

    const getData = async () => {

        var data = await getLaunchpadData();
        console.log("data>>>>", data);
        settotalLaunchPadlength(data)



        //  data.map(async(item,index) =>{
        //  var result = await UsegetSaleInfo(item?.presaleAddress);

        //  })
    }

    useEffect(() => {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "smooth"
        });
    }, []);



    return (
        <div className=''>
            {/* <Header /> */}
            <HeaderNew />
            <main className=''>

                <section className='section-videoBanner'>
                    <div className='section-videoBanner__videoContainer'>
                        <video autoPlay muted loop className='section-videoBanner__video' >
                            <source src={bannerVideo} type="video/mp4" />
                        </video>
                    </div>
                    <div className='container ai-container'>
                        <div className='section-videoBanner__content'>
                            <p className='section-videoBanner__content-title'>{section1 && section1?.Title}</p>
                            <p className='section-videoBanner__content-desc'>{section1 && section1?.Content}</p>
                        </div>
                    </div>
                </section>

                <section className='tabsection'>
                    <div className='container ai-container'>


                        <div className='menu_list position-relative'>
                            <div>
                                <Tabs defaultActiveKey="all" id="uncontrolled-tab-example" className='lnc-tabs' >
                                    {/* <Loader /> */}
                                    <Tab eventKey="all" title="All">
                                        {totalLaunchPadlength && totalLaunchPadlength.map((item, index) =>

                                        (item.pid == 2 || item.pid == 3 ?
                                            <LaunchpadCont data={item} pid={index} /> : <></>))}

                                    </Tab>
                                    {/* <Tab eventKey="launch1" title="7 Days" >
                                        {totalLaunchPadlength && totalLaunchPadlength.map((item, index) => (item.pid == 0 ? <LaunchpadCont data={item} pid={index} /> : <></>))}
                                    </Tab>
                                    <Tab eventKey="launch2" title="30 Days" >
                                        {totalLaunchPadlength && totalLaunchPadlength.map((item, index) => (item.pid == 1 ? <LaunchpadCont data={item} pid={index} /> : <></>))}
                                    </Tab> */}
                                    <Tab eventKey="launch3" title="365 Days" >
                                        {totalLaunchPadlength && totalLaunchPadlength.map((item, index) => (item.pid == 2 ? <LaunchpadCont data={item} pid={index} /> : <></>))}
                                    </Tab>
                                    <Tab eventKey="launch4" title="730 Days" >
                                        {totalLaunchPadlength && totalLaunchPadlength.map((item, index) => (item.pid == 3 ? <LaunchpadCont data={item} pid={index} /> : <></>))}
                                    </Tab>





                                </Tabs>

                            </div>

                        </div>

                    </div>
                </section>

            </main>
            <FooterNew />
        </div>
    )
}

export default Launchpad